/**
 * @description: 全局配置对象
 */
export var ConfigObject = {};

/**
 * @description: 全局配置方法
 */
export var ConfigFunc = {
  /**
   * @description: 传入自定义全局配置对象
   */
  set: function set(config) {
    // 遍历记录所有配置
    for (var key in config) {
      // 拷贝记录
      ConfigObject[key] = config[key];
    }
  }
};